import {
  CORPORATE_EVENT_DESER,
  CorporateEvent,
} from "../../tastyworks/corporate-event"
import type HttpClient from "../../tastyworks/http"
import type { ItemsResponse } from "../../tastyworks/response"

const parseCorporateEvent = CORPORATE_EVENT_DESER.toParser(CorporateEvent)

export class MarketMetricsService {
  private readonly marketMetricsClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.marketMetricsClient = baseHttpClient.nested("market-metrics")
  }

  readonly getHistoricDividends = async (
    symbol: string
  ): Promise<ItemsResponse<CorporateEvent>> =>
    this.marketMetricsClient.indexSimple(
      parseCorporateEvent,
      `historic-corporate-events/dividends/${encodeURIComponent(symbol)}`
    )
}
